import React from 'react';
import PropTypes from 'prop-types'; // ES6


function Tab(props) {
  const { label, onClick, activeTab } = props;
  const onTabClick = () => {
    onClick(label);
  };
  return (
    <li onClick={onTabClick} className={`tab-list-item ${activeTab===label ? 'tab-list-active' : ''}`}>
      {label}
    </li>
  );
}

Tab.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Tab;
